import { memo } from 'react';

interface ProgressBarProps {
  value: number;
  min?: number;
  max?: number;
  className?: string;
  trackClassName?: string;
  barClassName?: string;
}

const ProgressBar = memo(
  ({
    value,
    min = 0,
    max = 100,
    trackClassName = 'h-1.5 max-w-[200px] overflow-hidden rounded-[6px] bg-[#F4F9F8]',
    barClassName = 'h-full rounded-[6px] bg-[#4A6565] transition-[width]',
  }: ProgressBarProps) => {
    const percentage = Math.min(max, Math.max(min, value));

    return (
      <div
        className={trackClassName}
        role="progressbar"
        aria-valuenow={percentage}
        aria-valuemin={min}
        aria-valuemax={max}>
        <div className={barClassName} style={{ width: `${percentage}%` }} />
      </div>
    );
  },
);

ProgressBar.displayName = 'ProgressBar';

export default ProgressBar;
